import {useFormik} from "formik";
import {useContext, useEffect, useState} from "react";
import * as Yup from 'yup';
import FormFooter from "../../components/FormFooter";
import {MyContext} from "../../context/myContext";
import FormikInput from "../../components/FormikInput";
import {useDispatch, useSelector} from "react-redux";
import {addOrEditDriver, selectDriverInputsState, selectVolumeError, setVolumeError} from "./driverSlice";
import {selectAllCities, selectRegisterBtnType, selectShowEditForm, selectShowForm} from "../common-states/commonStatesSlice";

const AddDriverForm = () => {
    const {driverId} = useContext(MyContext)
    const addFormInputsState = {
        code: '', name: '', tankVolume: '', mobile: '', city: '', province: '', driverType: '',
        plateIran: '', plateThreeDigits: '', plateLetter: '', plateTwoDigits: '', description: ''
    }
    const [initialState, setInitialState] = useState(addFormInputsState)
    const dispatch = useDispatch()
    const registerBtnType = useSelector(selectRegisterBtnType)
    const volumeError = useSelector(selectVolumeError)
    const editFormInputsState = useSelector(selectDriverInputsState)
    const showForm = useSelector(selectShowForm)
    const showEditForm = useSelector(selectShowEditForm)
    const allCities = useSelector(selectAllCities)
    const formik = useFormik({
        initialValues: initialState,
        enableReinitialize: true,
        validationSchema: Yup.object().shape({
            code: Yup.string().required('کد ملی را وارد کنید').matches(/^(\d{10})$/g, 'کد ملی شامل ده رقم می شود!'),
            name: Yup.string().required('نام را وارد کنید').matches(/^[\u0600-\u06FF\\a-zA-Z\s]+$/g, 'فرمت را درست وارد کنید'),
            tankVolume: Yup.number().required('حجم تانکر را وارد کنید').typeError('به عدد وارد کنید'),
            mobile: Yup.string().required('شماره موبایل را وارد کنید').matches(/^09\d{9}$/g, 'شماره موبایل معتبر وارد کنید'),
            city: Yup.string().required('شهر خود را وارد کنید'),
            province: Yup.string().required('استان خود را وارد کنید'),
            driverType: Yup.string().required('نوع راننده را وارد کنید'),
        }),
        onSubmit: values => {
            dispatch(setVolumeError(''))
            console.log(values)
            let commonData = {
                city_id: values.city,
                user_id: localStorage.getItem('userId'),
                driver_type: (values.driverType === 'بخش دولتی' ? 0 : 1),
                mobile: values.mobile,
                name: values.name,
                plate: `${values.plateTwoDigits}${values.plateThreeDigits}${values.plateLetter}${values.plateIran}`,
                national_code: values.code,
                water_source_volume: values.tankVolume,
                description: values.description?.trim() || 'بدون توضیحات'
            }
            dispatch(addOrEditDriver({commonData, driverId, registerBtnType, dispatch}))
        }
    })

    useEffect(() => {
        if(showEditForm === true){
            const plateParts = String(editFormInputsState.numberPlate ?? '').match(/^([0-9۰-۹]{2})([0-9۰-۹]{3})([^0-9۰-۹]+)([0-9۰-۹]{2})$/)
            setInitialState({
                ...editFormInputsState,
                plateIran: plateParts?.[4] ?? '',
                plateThreeDigits: plateParts?.[2] ?? '',
                plateLetter: plateParts?.[3] ?? '',
                plateTwoDigits: plateParts?.[1] ?? ''
            })
        }
        else if(showForm === true){
            setInitialState(addFormInputsState)
        }
        // eslint-disable-next-line
    }, [showForm, showEditForm])

    useEffect(() => {
        formik.resetForm()
        dispatch(setVolumeError(''))
        // eslint-disable-next-line
    }, [showForm === false])

    const inputData = [
        {name: 'code', placeholder: 'کد ملی', hint: 'کدملی'}, {name: 'name', placeholder: 'نام و نام خانوادگی', hint: 'نام'}, {name: 'tankVolume', placeholder: 'حجم تانکر خودرو(لیتر)', hint: 'لیتر حجم تانکر'}, {name: 'mobile', placeholder: 'تلفن همراه', hint: 'همراه'},
    ]

    return(
        <form className='add-driver-form' onSubmit={formik.handleSubmit}>
            <div className='form-flex flex justify-around items-center flex-wrap py-5 [&>div]:form-flex-item [&_input]:grow [&_select]:grow
             [&_input]:input-styles [&_select]:select-styles [&_span]:text-red-600 [&_span]:ml-1 [&_p.error]:formik-error [&_p.error]:-bottom-[50%]
             [&_i]:input-hint-after-type [&_input]:w-full [&_input]:text-[10px] sm:[&_input]:text-xs [&_select]:text-[10px] sm:[&_select]:text-xs'
            >
                <FormikInput data={inputData} formik={formik} handleChange={formik.handleChange} />{/*This component represents four inputs*/}
                <div>
                    <select dir='rtl' name='city' value={formik.values.city} onChange={formik.handleChange} className='focus:shadow-focusShadow'>
                        <option value='' disabled>انتخاب شهر</option>
                        {allCities.map((item, index) => {
                            return <option key={index} value={item.city_id}>{item.name}</option>
                        })}
                    </select>
                    <span className='double-select-arrow right-4'></span>
                    <span>*</span>
                    {formik.touched.city && formik.errors.city ? <p className='error'>{formik.errors.city}</p> : null}
                </div>
                <div>
                    <select dir='rtl' name='province' value={formik.values.province} onChange={formik.handleChange} className='focus:shadow-focusShadow'>
                        <option value='' disabled>انتخاب استان</option>
                        <option value='خراسان جنوبی'>خراسان جنوبی</option>
                    </select>
                    <span className='double-select-arrow right-4'></span>
                    <span>*</span>
                    {formik.touched.province && formik.errors.province ? <p className='error'>{formik.errors.province}</p> : null}
                </div>
                <div>
                    <select dir='rtl' name='driverType' value={formik.values.driverType} onChange={formik.handleChange} className='focus:shadow-focusShadow'>
                        <option value='' disabled>نوع راننده</option>
                        <option value='بخش دولتی'>بخش دولتی</option>
                        <option value='بخش خصوصی'>بخش خصوصی</option>
                    </select>
                    <span className='double-select-arrow right-4'></span>
                    <span>*</span>
                    {formik.touched.driverType && formik.errors.driverType ? <p className='error'>{formik.errors.driverType}</p> : null}
                </div>
                <div dir='rtl' className='items-stretch gap-1 [&_input]:min-w-0 [&_input]:px-1'>
                    <div className='relative flex-[2]'>
                        <input type='text' inputMode='numeric' name='plateIran' placeholder='11' maxLength='2'
                               value={formik.values.plateIran} onChange={formik.handleChange}
                               className='focus:shadow-focusShadow !w-full !rounded-l-none' />
                        <small className='absolute right-1 top-0 text-[7px] text-gray-500'>ایران</small>
                    </div>
                    <input type='text' inputMode='numeric' name='plateThreeDigits' placeholder='425' maxLength='3'
                           value={formik.values.plateThreeDigits} onChange={formik.handleChange}
                           className='focus:shadow-focusShadow flex-[3] !rounded-none' />
                    <input type='text' name='plateLetter' placeholder='الف' maxLength='3'
                           value={formik.values.plateLetter} onChange={formik.handleChange}
                           className='focus:shadow-focusShadow flex-[2] !rounded-none' />
                    <input type='text' inputMode='numeric' name='plateTwoDigits' placeholder='24' maxLength='2'
                           value={formik.values.plateTwoDigits} onChange={formik.handleChange}
                           className='focus:shadow-focusShadow flex-[2] !rounded-r-none' />
                    <span>*</span>
                    {(formik.values.plateIran || formik.values.plateThreeDigits || formik.values.plateLetter || formik.values.plateTwoDigits) && <i>پلاک</i>}
                </div>
                <textarea name='description' placeholder='توضیحات' value={formik.values.description} onChange={formik.handleChange}
                          className='w-[70%] input-styles focus:shadow-focusShadow'
                >
                </textarea>
                {volumeError ? <p className='water-volume-error'>{volumeError}</p> : null}
            </div>
            <FormFooter />
        </form>
    )
}

export default AddDriverForm
